import { Controller } from 'react-hook-form'

import { Option } from '../Select/Select'
import { AsyncSelectProps, SelectAsync } from './SelectAsync'

interface Props<T extends { id: number; name: string | null }> extends Omit<AsyncSelectProps<T>, 'value'> {
  control: any
  onChange: (opt: Option) => void
}

export function SelectAsyncControlled<T extends { id: number; name: string | null }>({
  control,
  onChange,
  ...selectProps
}: Props<T>) {
  return (
    <Controller
      control={control}
      name={selectProps.name}
      render={({ field: { onChange: RHFonChange, value } }) => (
        <SelectAsync
          value={value}
          {...selectProps}
          onChange={(opt) => {
            RHFonChange(opt)
            onChange(opt)
          }}
        />
      )}
    />
  )
}
